import { FormControl } from "@mui/material";
import { memo, useCallback } from "react";
import CustomAsyncAutocomplete from "../../../../../core-components/theme/components/CustomAsyncAutoComplete";
interface ModuleSectionProps {
  value: string[];
  error?: string;
  disabled?: boolean;
  onChange: (value: string[]) => void;
}

const moduleOptions: string[] = ['Attendance', 'Task Escalation']

const ModuleSection = memo(({ value, error, disabled, onChange }: ModuleSectionProps) => {
  const handleModuleSelect = useCallback((selectedValue: any) => {
    onChange(selectedValue || []);
  }, [onChange]);

  return (
    <FormControl fullWidth error={!!error}>
      <CustomAsyncAutocomplete
        label="Module"
        placeholder="Select modules..."
        value={value}
        defaultOptions={moduleOptions}
        disabled={disabled}
        multiple
        onSelect={handleModuleSelect}
        error={!!error}
        errorText={error}
      />
    </FormControl>
  );
});

export default ModuleSection;